import {useContext} from 'react';
import {__RouterContext} from 'react-router';

// todo: discuss about this lint rule
// eslint-disable-next-line import/prefer-default-export
export function useRouter() {
  return useContext(__RouterContext);
}
